<div *ngIf="task; else no_task">

    <ng-container *ngIf="data">
        <h2 *ngIf="task.isProcess;else Zoning_code_statistic" mat-dialog-title>{{ task.typeStr }}</h2>
        <h4 *ngIf="task.isProcess">Statistic:</h4>
    </ng-container>

    <div class="mat-typography content">
        <app-process-status-row [process]="task"></app-process-status-row>
        <p>Index Parcels from State Layer: {{ task.indexStateLayerPRs }}</p>
        <p>Zoning code records (GAPI): {{ task.zoningCodeRecords }}</p>
        <p>Cached property records (ZAPI): {{
            task.totalPropertyRecords }}</p>
        <p>Current index position: {{ task.currentOffset }}</p>
        <p>Property records left: {{
            task.currentExpectedRecords }}</p>
        <p>Expected property records: {{ task.expectedRecords }}
        </p>
        <p>Currently received records: {{ task.receivedRecords }}
        </p>
        <p *ngIf="task['progress'] !== null">Progress: {{ task.progress }}%</p>
        <p>Failed data requests:
            {{ task.emptyResultAttempts }}
        </p>
        <p *ngIf="task.messages && task.messages.length" style="margin-bottom: 0px">Messages:</p>
        <div *ngIf="task.messages && task.messages.length" class="scrollableMessages">
            <mat-list>
                <ng-container *ngFor="let message of task.messages">
                    <p>{{message}}</p>
                </ng-container>
            </mat-list>
        </div>
        <div class="mat-typography">
            <p>Save PR Ids for investigation: {{task?.saveRawIds?'Yes':'No'}}
            </p>
        </div>
        <app-data-source-category-view
            [dataSourceCategories]="task.dataSourceCategories"></app-data-source-category-view>

        <div *ngIf="task.performance">
            <h4 mat-dialog-title>Performance statistic:</h4>
            <app-task-performance-details [task]="task"></app-task-performance-details>
        </div>
    </div>
</div>

<ng-template #no_task>
    <h2>Task not found</h2>
</ng-template>

<ng-template #Zoning_code_statistic>
    <h2>Zoning code statistic</h2>
</ng-template>